// @flow

import moment from 'moment';

export const toLocalDate = (date: any) => moment(date).format('YYYY-MM-DD[T]HH:mm:ss');
